import { AssessmentStepKeys } from '@/enums'
import { makeBusinessTypeSubmitValue } from '../../helpers'
import { ConditionalOfferAssessment } from './BasePage'

interface Messages {
  helperText: string
}

interface StepProps {
  [key: string]: {
    categoryId?: string
    helperText?: string
  }
}

interface SubmitValues {
  approxRevenue: any
  approxLaborCosts: any
  businessType: any
  companyFoundedDateLead: any
  [key: string]: any
}

const liabilityAssessmentSteps = [
  AssessmentStepKeys.businessTypeAi,
  AssessmentStepKeys.businessTypeConfirmationAi,
  AssessmentStepKeys.businessTypeMainSelectionAi,
  AssessmentStepKeys.companyFoundedDateLead,
  AssessmentStepKeys.approxRevenue,
  AssessmentStepKeys.employeesCount,
  AssessmentStepKeys.approxLaborCosts,
]

const categoryId = 'LI'

const makeSubmitValues = () => {
  return function transform<T>(values: T): T {
    const typedValues = (values as unknown) as SubmitValues
    const {
      approxRevenue,
      approxLaborCosts,
      businessType,
      companyFoundedDateLead,
      ...steps
    } = typedValues
    return ({
      ...steps,
      lastYearFinances: { ...approxLaborCosts, ...approxRevenue },
      businessType: makeBusinessTypeSubmitValue(businessType),
      companyFoundedDate: companyFoundedDateLead,
    } as unknown) as T
  }
}

const makeStepProps = (messages: Messages): StepProps => ({
  [AssessmentStepKeys.businessTypeConfirmationAi]: {
    categoryId,
  },
  [AssessmentStepKeys.approxRevenue]: {
    helperText: messages.helperText,
  },
  [AssessmentStepKeys.approxLaborCosts]: {
    helperText: messages.helperText,
  },
})

export const LiabilityConditionalOffer = () => (
  <ConditionalOfferAssessment
    categoryId={categoryId}
    makeStepProps={makeStepProps}
    stepKeys={liabilityAssessmentSteps}
    transformSubmitValues={makeSubmitValues()}
  />
)
